import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import rules from "../../rules";

const check = (role, action, data, userPermissions) => {
	if (userPermissions && action && action.startsWith("/")) {
		const [page, perm] = action.split(':');
		if (page && perm) {
			const pagePerms = userPermissions[page] || {};
			if (role === 'admin') {
				return pagePerms[perm] !== false; // Admins default to true
			} else {
				return pagePerms[perm] === true; // Operators default to false
			}
		}
	}

	const permissions = rules[role];
	if (!permissions) {
		// role is not present in the rules
		return false;
	}

	const staticPermissions = permissions.static;

	if (staticPermissions && staticPermissions.includes(action)) {
		// static rule not provided for action
		return true;
	}

	const dynamicPermissions = permissions.dynamic;

	if (dynamicPermissions) {
		const permissionCondition = dynamicPermissions[action];
		if (!permissionCondition) {
			// dynamic rule not provided for action
			return false;
		}

		return permissionCondition(data);
	}
	return false;
};

const Can = ({ role, perform, data, yes, no }) => {
	const { user } = useContext(AuthContext);
	let userPermissions = {};
	if (user?.permissions) {
		try {
			userPermissions = typeof user.permissions === 'string' ? JSON.parse(user.permissions) : user.permissions;
		} catch(e) {}
	}
	return check(role, perform, data, userPermissions) ? yes() : no();
};

Can.defaultProps = {
	yes: () => null,
	no: () => null,
};

export { Can };
